import { useTheme } from '../contexts/ThemeContext';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';

interface ThemeToggleProps {
  className?: string;
}

function ThemeToggle({ className = '' }: ThemeToggleProps): React.ReactElement {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative p-2 transition-all duration-300 hover:scale-110 ${className}`}
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      aria-label={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      <div className="relative w-6 h-6">
        <SunIcon 
          className={`absolute inset-0 w-6 h-6 transition-all duration-300 ${
            isDark 
              ? 'opacity-100 rotate-0 text-amber-400' 
              : 'opacity-0 rotate-90 text-amber-400'
          }`}
        />
        <MoonIcon 
          className={`absolute inset-0 w-6 h-6 transition-all duration-300 ${
            isDark 
              ? 'opacity-0 -rotate-90 text-slate-600' 
              : 'opacity-100 rotate-0 text-slate-600'
          }`}
        />
      </div>
    </button>
  );
}

export default ThemeToggle;
